import * as React from 'react';

const SpecificationListItem = ({ label , value  })=>/*#__PURE__*/ React.createElement("div", {
        className: "product-detail-specification__item",
        role: "presentation"
    }, /*#__PURE__*/ React.createElement("dt", {
        className: "product-detail-specification__item--label"
    }, label), /*#__PURE__*/ React.createElement("dd", {
        className: "product-detail-specification__item--value"
    }, value))
;

export { SpecificationListItem };
//# sourceMappingURL=SpecificationListItem.js.map
